<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Production Quality Inspection Visual" active>

                                <b-row v-if="hasFailedDataProductionQualityInspectionVisual">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionQualityInspectionVisual.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionVisualsFailed" :fields="fieldsProductionQualityInspectionVisual" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionVisual" :sort-desc.sync="sortDescProductionQualityInspectionVisual" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionQualityInspectionVisual.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionVisuals" :fields="fieldsProductionQualityInspectionVisual" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionVisual" :sort-desc.sync="sortDescProductionQualityInspectionVisual" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Production Quality Inspection Visual Detail" active>

                                <b-row v-if="hasFailedDataProductionQualityInspectionVisualDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedProductionQualityInspectionVisualDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionVisualDetailsFailed" :fields="fieldsProductionQualityInspectionVisualDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionVisualDetail" :sort-desc.sync="sortDescProductionQualityInspectionVisualDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(ngQty)="row">
													{{ Number(row.item.ngQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedProductionQualityInspectionVisualDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="productionQualityInspectionVisualDetails" :fields="fieldsProductionQualityInspectionVisualDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByProductionQualityInspectionVisualDetail" :sort-desc.sync="sortDescProductionQualityInspectionVisualDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(ngQty)="row">
													{{ Number(row.item.ngQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ProductionQualityInspectionVisual from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual';
import ProductionQualityInspectionVisualList from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualList';
import ProductionQualityInspectionVisualFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsProductionQualityInspectionVisual: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Detail", key: 'workOrderProcessDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Work Order Execution Detail", key: 'workOrderExecutionDetailWorkOrderProcessDetail', sortable: false},
				{"class" : "th-status", "label" : "ProductionDate", key: 'productionDate', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsProductionQualityInspectionVisualDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Execution Ng", key: 'workOrderExecutionNgWorkOrderExecutionDetail', sortable: false},
				{"class" : "th-status", "label" : "Ng Category", key: 'problemCategoryCode', sortable: false},
				{"class" : "th-status", "label" : "Ng Qty", key: 'ngQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			productionQualityInspectionVisuals : [],
			productionQualityInspectionVisualsFailed: [],
			productionQualityInspectionVisualId : '',
			sortByProductionQualityInspectionVisual: '',
			sortDescProductionQualityInspectionVisual: '',
			hasFailedDataProductionQualityInspectionVisual: false,
			totalFailedProductionQualityInspectionVisual: 0,
			totalSucceedProductionQualityInspectionVisual: 0,
			productionQualityInspectionVisualDetails : [],
			productionQualityInspectionVisualDetailsFailed: [],
			productionQualityInspectionVisualDetailId : '',
			sortByProductionQualityInspectionVisualDetail: '',
			sortDescProductionQualityInspectionVisualDetail: '',
			hasFailedDataProductionQualityInspectionVisualDetail: false,
			totalFailedProductionQualityInspectionVisualDetail: 0,
			totalSucceedProductionQualityInspectionVisualDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('productionqualityinspectionvisual/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('productionqualityinspectionvisual/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getProductionQualityInspectionVisualForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getProductionQualityInspectionVisualForUpload : async function() {
			let _this = this;
			this.$http.get('productionqualityinspectionvisual/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.productionQualityInspectionVisuals = [];
_this.productionQualityInspectionVisualDetails = [];


					if (response != null) {
						let result = response.data;
						_this.productionQualityInspectionVisuals = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedProductionQualityInspectionVisual = _this.productionQualityInspectionVisuals.length;

						_this.productionQualityInspectionVisualsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataProductionQualityInspectionVisual = true;
						_this.totalFailedProductionQualityInspectionVisual = 0;
						if(_this.productionQualityInspectionVisualsFailed == undefined || _this.productionQualityInspectionVisualsFailed.length === 0) _this.hasFailedDataProductionQualityInspectionVisual = false;
						if(_this.hasFailedDataProductionQualityInspectionVisual) _this.totalFailedProductionQualityInspectionVisual = _this.productionQualityInspectionVisualsFailed.length;
						_this.productionQualityInspectionVisualDetails = [];
						_this.productionQualityInspectionVisualDetailsFailed = [];
						_this.hasFailedDataProductionQualityInspectionVisualDetail = true;
						_this.totalSucceedProductionQualityInspectionVisualDetail = 0;
						result.forEach(function(element) {
							_this.productionQualityInspectionVisualDetails.push(...element.productionQualityInspectionVisualDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedProductionQualityInspectionVisualDetail = _this.productionQualityInspectionVisualDetails.length;

							_this.productionQualityInspectionVisualDetailsFailed.push(...element.productionQualityInspectionVisualDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.productionQualityInspectionVisualDetailsFailed == undefined || _this.productionQualityInspectionVisualDetailsFailed.length === 0) _this.hasFailedDataProductionQualityInspectionVisualDetail = false;
							if(_this.hasFailedDataProductionQualityInspectionVisualDetail) _this.totalFailedProductionQualityInspectionVisualDetail = _this.productionQualityInspectionVisualDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'productionqualityinspectionvisual/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ProductionQualityInspectionVisual.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterProductionQualityInspectionVisual = new ProductionQualityInspectionVisualFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
